
import request from '@/utils/request'

export function auctionList(data) {
  return request({
    url: '/auction/list',
    method: 'get',
    params: data
  })
}
export function auctionDetailList(data) {
  return request({
    url: '/auction/detail',
    method: 'get',
    params: data
  })
}
export function myHistorylist(data) {
  return request({
    url: '/auction/mylist',
    method: 'get',
    params: data
  })
}
